module.exports = __webpack_public_path__ + "static/img/mylogo.58be94b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mylogo.png
// module id = UX5u
// module chunks = 56